export const CONTROLS_BAR_HEIGHT = 40;
export const CLOSE_BAR_HEIGHT_SMALL = 24;
export const CLOSE_BAR_HEIGHT_BIG = 40;
export const READ_MORE_HEIGHT_SMALL = 24;
export const READ_MORE_HEIGHT_BIG = 40;
export const MORE_VIDEOS_LARGE_HEIGHT = 111;
export const MORE_VIDEOS_EXTRA_LARGE_HEIGHT = 142;

export const SEEK_BAR_HEIGHT_SMALL = 2;
export const SEEK_BAR_HEIGHT_MEDIUM = 3;
export const SEEK_BAR_HEIGHT_LARGE = 4;
